// Global
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { classnames } from 'tailwindcss-classnames';
// Components
import Container from 'components/helpers/Container';
import PlaceholderWrapper from 'components/helpers/PlaceholderWrapper/PlaceholderWrapper';
import { Components } from '.generated/templates/Feature.Components.model';
import Heading, { propsFromFields } from 'components/helpers/Heading';
import { MissingDataSource } from 'components/helpers/EditingHelpText';

export type LayoutRightThirdProps = Sitecore.Override.ComponentBase &
  Components.Layout.Fields.ColumnLayout;

export type LayoutRightThirdShellProps = {
  left: JSX.Element;
  right: JSX.Element;
};

export const LayoutRightThirdShell = ({ left, right }: LayoutRightThirdShellProps): JSX.Element => {
  const rightPlaceholder = right.props.rendering?.placeholders['nmdp-one-third-right'];
  const rightPlaceholderIsEmpty = rightPlaceholder && rightPlaceholder.length === 0;

  return (
    <div className={classnames('md:grid', 'grid-cols-3', 'md:gap-5', 'lg:gap-7')}>
      <div
        className={classnames(
          'col-span-2',
          { 'mb-10': !rightPlaceholderIsEmpty, 'mb-0': rightPlaceholderIsEmpty },
          'md:mb-0'
        )}
      >
        {left}
      </div>
      <div className={classnames('col-span-1')}>{right}</div>
    </div>
  );
};

const LayoutRightThird = ({ rendering, fields }: LayoutRightThirdProps): JSX.Element => {
  if (fields === null || fields === undefined) {
    return <MissingDataSource />;
  }

  const headingProps = propsFromFields(fields);

  return (
    <Container size="standard" dataComponent="authorable/layout/layout-right-third">
      <div className={fields?.description.value ? classnames('mb-8') : ''}>
        <Heading {...headingProps} descriptionClassName={classnames('text-base')} />
      </div>
      <LayoutRightThirdShell
        left={<PlaceholderWrapper name="nmdp-two-thirds-width" rendering={rendering} />}
        right={<PlaceholderWrapper name="nmdp-one-third-right" rendering={rendering} />}
      />
    </Container>
  );
};

export default LayoutRightThird;
